import { render, staticRenderFns } from "./orders-list-table.component.vue?vue&type=template&id=06ba4e7e"
import script from "./orders-list-table.component.vue?vue&type=script&lang=js"
export * from "./orders-list-table.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports